export default __webpack_public_path__ + "static/media/eth-network.2e70bfe4.svg";